/* global axios */
import Auth from 'dashboard/api/auth';
import { createMediaPool, fetchMediaWithRetry } from './authenticatedMedia.mjs';

const pool = createMediaPool({
  fetchBlob: source => fetchMediaWithRetry(
    async url => (await axios.get(url, { responseType: 'blob', timeout: 20000, headers: { 'Cache-Control': 'no-cache' } })).data,
    source
  ),
  createUrl: blob => URL.createObjectURL(blob),
  revokeUrl: url => URL.revokeObjectURL(url),
});

export function sameOriginMedia(source) {
  try { return new URL(source, window.location.origin).origin === window.location.origin; }
  catch { return false; }
}

function mediaKey(source) {
  const auth = Auth.getAuthData() || {};
  return `${auth.uid || ''}:${auth.client || ''}:${source}`;
}

export function invalidateMedia(source) { pool.invalidate(mediaKey(source)); }

export function acquireMedia(source) {
  // Never send Chatwoot authentication to an external attachment origin.
  if (!sameOriginMedia(source)) throw new Error('Media origin is not authenticated');
  return pool.acquire(mediaKey(source), source);
}
